// TODO Summira Migrate this component to the new angular
class ExamPhotosOldController {
  constructor($rootScope, $scope, ngDialog, Logger, Media, Notifications, Orders, Constants) {
    //services have already been migrated to the new angular. For references, look at the idPhoto file in the new angular
    'ngInject';

    Object.assign(this, {
      $rootScope,
      ngDialog,
      Logger,
      Media,
      Notifications,
      Orders,
      Constants,
      loading: false,
      error: null,
      errorMessage: '',
      hasAccess: true,
      photos: [],
      diagnosis: null,
      task: null
    });
  }
  $onInit() {
    this.init();
  }
  init() {
    this.task = this.visit.getTask(this.Orders.TASKS.EXAM_PHOTO);
    this.loading = true;
    this.Orders.getExamPhotos()
      .then(({ data }) => {
        const { diagnosis } = data;

        const photos = data.photos.map(photo => ({
          ...photo,
          rejected: photo.file.status === this.Constants.PhotoStatuses.Rejected,
          deleted: photo.file.status === this.Constants.PhotoStatuses.Deleted,
          approved: photo.file.status === this.Constants.PhotoStatuses.Approved,
        }));

        Object.assign(this, {
          error: null,
          photos,
          diagnosis,
        });
      })
      .catch(err => {
        this.error = err.status === 404 ? 'No Photos Uploaded' : 'Error Downloading Photos';
        this.errorMessage = err.status === 403 ? 'Access request needed to view these photos' : '';
        this.hasAccess = err.status !== 403;
      })
      .finally(() => this.loading = false);
  }
  reload() {
    this.init();
  }
  approve(payload) {
    const reviews = payload.photos.map(photo => ({
      file_id: photo.file.id,
      approved: true,
      notes: photo.notes
    }));
    this.updatePhotoTask({
      reviews
    }, true);
  }
  reject(payload) {
    const reviews = payload.photos.filter(photo => photo.rejected).map(photo => ({
      file_id: photo.file.id,
      approved: false,
      notes: photo.notes,
      rejection_note: photo.file.rejection_note
    }));
    this.updatePhotoTask({
      reviews
    }, false);
  }

  updatePhotoTask(payload, approved) {
    this.Orders.setExamPhotos(this.visit.id, payload).then(() => {
      // Set task status based on approval or rejection
      this.task.status = approved ? this.Orders.STATUS.APPROVED : this.Orders.STATUS.REJECTED;
      this.visit.admin_status = approved ? 5.4 : 5.5;
      this.photos = this.photos.map((photo) => {
        const isRejected = !approved && payload.reviews.find(({ file_id }) => file_id === photo.file.id);
        return {
          ...photo,
          file: {
            ...photo.file,
            status: approved
              ? this.Constants.PhotoStatuses.Approved
              : isRejected
                ? this.Constants.PhotoStatuses.Rejected
                : photo.file.status
          },
          rejected: isRejected,
          approved,
        };
      });

      this.$rootScope.$broadcast('photos:updated', approved);
      this.$rootScope.$broadcast('visit:refresh');
    }).catch(err => {
      if (err.data.status == 403) {
        this.errorMessage = this.Notifications.orders.locked;
      } else if (err.data.message && err.data.message.summary) {
        this.errorMessage = err.data.message.summary;
      } else {
        this.errorMessage = this.Notifications.orders.photos.failed;
      }
    });
  }
}
ExamPhotosOldController.$inject = ["$rootScope", "$scope", "ngDialog", "Logger", "Media", "Notifications", "Orders", "Constants"];
angular.module('pims').component('examPhotosOld', {
  templateUrl: 'app/views/visits/detail/sections/photos/exam/examPhotosOld.html',
  controller: ExamPhotosOldController,
  controllerAs: 'vm',
  bindings: {
    visit: '='
  }
});
